import Vue from 'vue'
const list = require('countries-list').countries

const Countries = {
  install: (Vue) => {
    const filtered = ['CZ', 'SK'].map((key) => {
      var c = list[key]
      c.code = key
      return c
    })
    const root = new Vue({
      data: {
        countries: filtered
      }
    })
    Vue.prototype.$countries = root
  }
}
Vue.use(Countries)
